import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/UserSlice";
import authReducer from "../slices/authSlice";
import LoginMiddleware from "../middleware/LoginMiddleware";
import roleReducer from "../slices/roleSlice";
import companyReducer from "../slices/companySlice";
import unitReducer from "../slices/unitSlice";
import categoryReducer from "../slices/categorySlice";
import productReducer from "../slices/productSlice";
import agentReducer from "../slices/agentSlice";
import invoiceReducer from "../slices/invoiceSlice";
import customerReducer from "../slices/customerSlice";
import balanceSheetReducer from "../slices/balanceSheetSlice";
const store = configureStore({
  reducer: {
    users: userReducer,
    auth: authReducer,
    roles: roleReducer,
    company: companyReducer,
    unit: unitReducer,
    category: categoryReducer,
    product: productReducer,
    agent: agentReducer,
    invoice: invoiceReducer,
    customer: customerReducer,
    balanceSheet: balanceSheetReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(LoginMiddleware),
});
export default store;
